// extracted by mini-css-extract-plugin
module.exports = {"parent":"pet_parent__3tjRh"};